var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person-list"},[_c('time-range-filter',{on:{"time-range-change":_vm.timeRangeChange,"time-range-export":_vm.exportReport}}),_vm._v(" "),_c('data-table',{attrs:{"title":"Move Ins by Month","headers":_vm.headers,"fields":_vm.fields,"items":_vm.residents}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e6b0266","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/person/residents/reports/MoveInsByMonth.vue
// module id = cwI+
// module chunks = 0 1